import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import cubex_logo from "../../assets/Logo-bg.png";
import { config } from "../../config";

const links = [
  { label: "Home", path: `${config.appUrl}` },
  { label: "About", path: `${config.appUrl}about` },
  {
    label: "Services",
    path: `${config.appUrl}services`,
    sub: [
      {
        label: "🌐 Website Development",
        path: `${config.appUrl}services/web-development`,
      },
      {
        label: "📈 Digital Marketing",
        path: `${config.appUrl}services/digital-marketing`,
      },
      {
        label: "🎨 Graphics Design",
        path: `${config.appUrl}services/graphics-design`,
      },
    ],
  },
  {
    label: "Packages",
    path: "#",
    sub: [
      {
        label: "💻 Web Dev Package",
        path: `${config.appUrl}web-development-package`,
      },
      {
        label: "🛡️ Maintenance Package",
        path: `${config.appUrl}maintenance-package`,
      },
    ],
  },
  { label: "Contact", path: `${config.appUrl}contact` },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [drop, setDrop] = useState(null);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    setOpen(false);
    setDrop(null);
  }, [loc]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    // Cleanup on unmount so body scroll is never permanently locked
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  const closeMenu = () => setOpen(false);

  return (
    <>
      <nav className={scrolled ? "scrolled" : ""}>
        <Link to={`${config.appUrl}`} className="nav-logo">
          <img src={cubex_logo} />
        </Link>

        <ul className="nav-links">
          {links.map((l) => (
            <li
              key={l.label}
              className="nav-item"
              onMouseEnter={() => l.sub && setDrop(l.label)}
              onMouseLeave={() => setDrop(null)}
            >
              <NavLink
                to={l.path}
                className={({ isActive }) =>
                  isActive && l.path !== "#" ? "active" : ""
                }
                end={l.path === "/"}
              >
                {l.label}
                {l.sub && (
                  <svg width="10" height="6" viewBox="0 0 10 6">
                    <path
                      d="M1 1l4 4 4-4"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      fill="none"
                    />
                  </svg>
                )}
              </NavLink>

              {l.sub && drop === l.label && (
                <div className="dropdown">
                  {l.sub.map((s) => (
                    <Link key={s.label} to={s.path} className="dropdown-item">
                      {/* <span className="dot"/> */}
                      {s.label}
                    </Link>
                  ))}
                </div>
              )}
            </li>
          ))}
          <li>
            <Link to={`${config.appUrl}contact`} className="nav-cta">
              Start Project
            </Link>
          </li>
        </ul>

        <button
          className={`hamburger${open ? " open" : ""}`}
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
          aria-controls="mobile-drawer"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>
      {open && (
        <div
          className="mobile-backdrop"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      <div
        id="mobile-drawer"
        className={`mobile-drawer${open ? " open" : ""}`}
        aria-hidden={!open}
      >
        <div className="mobile-inner">
          {links.map((l, i) => (
            <div
              key={l.label}
              className="m-group"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              {l.sub ? (
                <>
                  <span className="m-label">{l.label}</span>
                  {l.sub.map((s) => (
                    <Link
                      key={s.label}
                      to={s.path}
                      className="m-sub"
                      onClick={closeMenu} // ← close on link click
                    >
                      {s.label}
                    </Link>
                  ))}
                </>
              ) : (
                <NavLink
                  to={l.path}
                  className={({ isActive }) =>
                    `m-link${isActive && l.path !== "#" ? " active" : ""}`
                  }
                  end={l.path === `${config.appUrl}`}
                  onClick={closeMenu} // ← close on link click
                >
                  {l.label}
                </NavLink>
              )}
            </div>
          ))}

          <Link
            to={`${config.appUrl}contact`}
            className="btn-primary"
            style={{ marginTop: 24, justifyContent: "center" }}
            onClick={closeMenu}
          >
            Start Project
          </Link>
        </div>
      </div>
    </>
  );
}
